import { configureStore } from '@reduxjs/toolkit'
import Logo from 'src/assets/brand/pa_logo_lg.png'
import LogoDark from 'src/assets/brand/pa_logo_lg_dark.png'

const getInitialLogo = () => {
  if (typeof window !== 'undefined' && window.localStorage.getItem('darkMode') === 'true') {
    return LogoDark
  }

  return Logo
}

const initialState = {
  sidebarShow: true,
  sidebarUnfoldable: false,
  logo: getInitialLogo(),
}

// Reducer function to handle state updates
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'set':
      return {
        ...state,
        ...action,
      }
    case 'SET_LOGO':
      return {
        ...state,
        logo: action.payload,
      }
    // case 'SET_FOOD_BG':
    //   return {
    //     ...state,
    //     foodBg: action.payload,
    //   }
    default:
      return state
  }
}

// Create the Redux store
const store = configureStore({
  reducer: reducer,
})

export default store
